import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { fireCustomErrorAnalytics } from '@atlassian/jira-servicedesk-knowledge-common/src/common/utils';
import { list as listArticles } from '@atlassian/jira-servicedesk-knowledge-services/src/services/articles/index.tsx';
import { BROWSE_KNOWLEDGE, type BrowseKnowledgeAction } from '../../state/actions/browse-knowledge';
import { browseKnowledgeFailure } from '../../state/actions/browse-knowledge-failure';
import { browseKnowledgeSuccess } from '../../state/actions/browse-knowledge-success';
import { getActivationId, getProjectId } from '../../state/selectors/base';
import { getBrowseLimit } from '../../state/selectors/browse';
import type { State } from '../../state/types';
import { PACKAGE_NAME } from '../../view/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(BROWSE_KNOWLEDGE).mergeMap((action: BrowseKnowledgeAction) => {
		const page = action.payload.page || 1;
		const state = store.getState();
		const limit = action.payload.limit || getBrowseLimit(state);
		const projectId = getProjectId(state);
		const spaceKey = action.payload.spaceKey ?? '';
		const cursor = action.payload.cursor ?? '';
		const activationId = getActivationId(state);
		let requestParams = {
			categoryId: action.payload.id,
			expand: action.payload.expand,
			orderby: action.payload.orderBy,
			limit,
		};
		const query = action.payload.query != null ? action.payload.query : '';
		if (query) {
			// @ts-expect-error - TS2322 - Type '{ query: string; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
			requestParams = { ...requestParams, query };
		}
		if (spaceKey) {
			// @ts-expect-error - TS2322 - Type '{ spaceKey: string[]; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
			requestParams = { ...requestParams, spaceKey };
		}
		if (cursor) {
			// @ts-expect-error - TS2322 - Type '{ cursor: string; categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }' is not assignable to type '{ categoryId: string; expand: Expand[] | undefined; orderby: OrderBy | undefined; limit: number; }'.
			requestParams = { ...requestParams, cursor };
		}

		const { createAnalyticsEvent } = action.payload;
		const EVENT_NAME =
			requestParams.categoryId !== 'all-articles' ? 'browseArticleInCategory' : 'browseArticles';
		return listArticles(projectId, activationId, requestParams)
			.map((response) => {
				if (createAnalyticsEvent) {
					const analyticsEvent = createAnalyticsEvent({});
					fireTrackAnalytics(analyticsEvent, `${EVENT_NAME} success`, {
						projectId,
					});
				}
				return browseKnowledgeSuccess({
					id: action.payload.id,
					...response,
					page,
				});
			})
			.catch((error) => {
				const { statusCode } = error;
				if (createAnalyticsEvent) {
					fireCustomErrorAnalytics({
						error,
						event: createAnalyticsEvent({}),
						id: `${EVENT_NAME} failure`,
						packageName: PACKAGE_NAME,
					});
				}
				return Observable.of(
					browseKnowledgeFailure({
						id: action.payload.id,
						page,
						statusCode,
					}),
				);
			});
	});
